import SocialButton from 'src/components/consumptionPage/ConsumptionMetaData/SocialButtons/SocialButton';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { ContentItemType } from 'src/utils/commonTypes';
import { ASSET_SUBTYPE } from 'src/utils/constants/AppConstants';
import {
  IconsSetType,
  Zee5PlayerIconsSet
} from 'src/utils/constants/IconsConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  MIXPANEL_BUTTON,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_WATCH_TRAILER
} from '../../../utils/analytics/mixpanel/mixpanelConstants';
import { ctaEvent } from '../../../utils/analytics/mixpanel/mixpanelEventsHelper';

type WatchTrailerBtnType = {
  metaButtonItems: ContentItemType;
  singlePlayData: any;
  getSinglePlayDetails: (spApiObject: any) => void;
};

const WatchTrailerBtn = ({
  metaButtonItems,
  singlePlayData,
  getSinglePlayDetails
}: WatchTrailerBtnType) => {
  const { translations } = useAppStore();
  const translationData = translations?.consumption;
  const { TRAILER } = translationData || {};

  // if it has error codes then should not show the trailer button as they are non trailer content
  const shouldDisableTrailerEvent =
    (singlePlayData &&
      Object.keys(singlePlayData).length &&
      (singlePlayData?.error_code ||
        (singlePlayData?.entitlement &&
          singlePlayData?.entitlement?.isTrailer))) ||
    singlePlayData?.assetDetails?.asset_subtype === ASSET_SUBTYPE.TRAILER;
  const trailerCallback = () => {
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_WATCH_TRAILER);
    mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_BUTTON);
    ctaEvent();
    if (metaButtonItems.id !== metaButtonItems?.trailerData?.id) {
      getSinglePlayDetails(metaButtonItems?.trailerData || {}); //call spapi
      // update contentId, primaryMediaId states
    }
  };

  const onClickHandler = (e: any) => {
    e.preventDefault();
    trailerCallback();
  };

  return (
    <>
      {!shouldDisableTrailerEvent ? (
        <div data-testid="trailer-btn-container">
          <SocialButton
            icon={Zee5PlayerIconsSet.PLAY}
            type={IconsSetType.ZEE5_PLAYER}
            name={TRAILER}
            action={onClickHandler}
            id={
              shouldDisableTrailerEvent ? 'disabled-trailer-btn' : 'trailer-btn'
            }
          />
        </div>
      ) : null}
    </>
  );
};

export default WatchTrailerBtn;
